import { App } from './../app.class';
import { Modal } from './../modal.class';
import { Notification } from './../notification.class';
import { Fetch } from '../../fetch.class';

export class Page {

    constructor() {

        // Formular-Code
        this.$formCode = document.querySelector('header .form_code');
        this.form_code = this.$formCode.textContent;

        // Basis-URL zu Prozessor
        this.baseUrl = App.getUrl('form-delivery')+"/"+this.form_code+"/autoresponse";


        // --- Feldname

        // Elemente
        this.$btnEditFieldname = document.querySelector('button.fieldname');
        this.$inputEditFieldname = document.querySelector('#modal-edit-fieldname input[name=fieldname]');
        this.$displayFieldname = document.querySelector('#value_fieldname');
        this.$formEditFieldname = document.querySelector('#modal-edit-fieldname form');
        this.$errorboxEditFieldname = document.querySelector('#modal-edit-fieldname .errorbox');

        // Modal
        this.modalEditFieldname = new Modal('#modal-edit-fieldname');

        // Modaldialog öffnen
        this.$btnEditFieldname.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditFieldname.classList.add('hidden');

            // Modal öffnen
            this.modalEditFieldname.show();
        });

        // Speicherung
        this.$formEditFieldname.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("fieldname", this.$inputEditFieldname.value);

            // Fehler ausblenden
            this.$errorboxEditFieldname.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_fieldname", data)
            .then(response => {

                // Modal schliessen
                this.modalEditFieldname.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayFieldname.textContent = this.$inputEditFieldname.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditFieldname.querySelector('.cont').textContent = error.message;
                this.$errorboxEditFieldname.classList.remove('hidden');
            });
        });

        // --- Absendername

        // Elemente
        this.$btnEditFromName = document.querySelector('button.mailfromname');
        this.$inputEditFromName = document.querySelector('#modal-edit-mailfromname input[name=mail_from_name]');
        this.$displayFromName = document.querySelector('#value_mailfromname');
        this.$formEditFromName = document.querySelector('#modal-edit-mailfromname form');
        this.$errorboxEditFromName = document.querySelector('#modal-edit-mailfromname .errorbox');

        // Modal
        this.modalEditFromName = new Modal('#modal-edit-mailfromname');

        // Modaldialog öffnen
        this.$btnEditFromName.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditFromName.classList.add('hidden');

            // Modal öffnen
            this.modalEditFromName.show();
        });

        // Speicherung
        this.$formEditFromName.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("mail_from_name", this.$inputEditFromName.value);

            // Fehler ausblenden
            this.$errorboxEditFromName.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_mailfromname", data)
            .then(response => {

                // Modal schliessen
                this.modalEditFromName.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayFromName.textContent = this.$inputEditFromName.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditFromName.querySelector('.cont').textContent = error.message;
                this.$errorboxEditFromName.classList.remove('hidden');
            });
        });

        // --- Antwortadresse

        // Elemente
        this.$btnEditReplyAddress = document.querySelector('button.mailreplyaddress');
        this.$inputEditReplyAddress = document.querySelector('#modal-edit-mailreplyaddress input[name=mail_reply_address]');
        this.$displayReplyAddress = document.querySelector('#value_mailreplyaddress');
        this.$formEditReplyAddress = document.querySelector('#modal-edit-mailreplyaddress form');
        this.$errorboxEditReplyAddress = document.querySelector('#modal-edit-mailreplyaddress .errorbox');

        // Modal
        this.modalEditReplyAddress = new Modal('#modal-edit-mailreplyaddress');

        // Modaldialog öffnen
        this.$btnEditReplyAddress.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditReplyAddress.classList.add('hidden');

            // Modal öffnen
            this.modalEditReplyAddress.show();
        });

        // Speicherung
        this.$formEditReplyAddress.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("mail_reply_address", this.$inputEditReplyAddress.value);

            // Fehler ausblenden
            this.$errorboxEditReplyAddress.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_mailreplyaddress", data)
            .then(response => {

                // Modal schliessen
                this.modalEditReplyAddress.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displayReplyAddress.textContent = this.$inputEditReplyAddress.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditReplyAddress.querySelector('.cont').textContent = error.message;
                this.$errorboxEditReplyAddress.classList.remove('hidden');
            });
        });

        // --- Betreff

        // Elemente
        this.$btnEditSubject = document.querySelector('button.mailsubject');
        this.$inputEditSubject = document.querySelector('#modal-edit-mailsubject input[name=mailsubject]');
        this.$displaySubject = document.querySelector('#value_mailsubject');
        this.$formEditSubject = document.querySelector('#modal-edit-mailsubject form');
        this.$errorboxEditSubject = document.querySelector('#modal-edit-mailsubject .errorbox');

        // Modal
        this.modalEditSubject = new Modal('#modal-edit-mailsubject');

        // Modaldialog öffnen
        this.$btnEditSubject.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditSubject.classList.add('hidden');

            // Modal öffnen
            this.modalEditSubject.show();
        });

        // Speicherung
        this.$formEditSubject.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("mail_subject", this.$inputEditSubject.value);

            // Fehler ausblenden
            this.$errorboxEditSubject.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_mailsubject", data)
            .then(response => {

                // Modal schliessen
                this.modalEditSubject.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                this.$displaySubject.textContent = this.$inputEditSubject.value;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditSubject.querySelector('.cont').textContent = error.message;
                this.$errorboxEditSubject.classList.remove('hidden');
            });
        });

        // --- Textinhalt

        // Elemente
        this.$btnEditContent = document.querySelector('button.mailcontent');
        this.$inputEditContent = document.querySelector('#modal-edit-mailcontent textarea[name=mailcontent]');
        this.$displayContent = document.querySelector('#value_mailcontent');
        this.$formEditContent = document.querySelector('#modal-edit-mailcontent form');
        this.$errorboxEditContent = document.querySelector('#modal-edit-mailcontent .errorbox');

        // Modal
        this.modalEditContent = new Modal('#modal-edit-mailcontent');

        // Modaldialog öffnen
        this.$btnEditContent.addEventListener('click', event => {

            // Fehlermeldung ausblenden
            this.$errorboxEditContent.classList.add('hidden');

            // Modal öffnen
            this.modalEditContent.show();
        });

        // Speicherung
        this.$formEditContent.addEventListener('submit', event => {

            event.preventDefault();

            const data = new FormData();
            data.append("mail_content", this.$inputEditContent.value);

            // Fehler ausblenden
            this.$errorboxEditContent.classList.add('hidden');

            // Senden
            new Fetch().post(this.baseUrl+"/save_mailcontent", data)
            .then(response => {

                // Modal schliessen
                this.modalEditContent.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // in Anzeige übernehmen
                let text = this.$inputEditContent.value;
                text = (text + '').replace(/[\u00A0-\u9999<>\&]/g, ((i) => `&#${i.charCodeAt(0)};`));
                text = (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
                this.$displayContent.innerHTML = text;
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditContent.querySelector('.cont').textContent = error.message;
                this.$errorboxEditContent.classList.remove('hidden');
            });
        });

    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-delivery-autoresponse')) {
        new Page();
    }
});